/* eslint-disable react-hooks/exhaustive-deps */

import { AlertTost, CropProtectionComponent } from "#components";
import globalConfig from "#constants/globalConfig.js";
import useGet from "#hooks/useGet.js";
import usePost from "#hooks/usePost.js";
import { WebRoutePath } from "#routes/routePath.jsx";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import {
  numberOnly,
  transformCropPlanData,
  transformData,
} from "#utils/helpers.js";
import { cropPlanInitialValues } from "#validations/initialValues.js";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  CalculateActualValue,
  CalculateSumOfActualValues,
} from "../../../components/cropPlan/addCropPlan/calculation";
import CropPlanModelFieldList from "../addCropPlan/cropPlanModelFieldList";
import { WebLayout } from "#layouts";
import FertilityComponent from "../../../components/cropPlan/addCropPlan/fertilityComponent";
import SeedComponent from "../../../components/cropPlan/addCropPlan/seedComponent";
import { ClipLoader } from "react-spinners";
import CropAddProductModel from "../addCropPlan/cropAddProductModel";
import AddCropModel from "../addCropPlan/addCropModel";
import CustomAlert from "../../../components/CustomAlert";
import { useQueryClient } from "react-query";

const CropPlaneEdit = () => {
  const selectedSeasonId = localStorage.getItem(globalConfig.SEASON_ID);
  const GrowerId = JSON.parse(localStorage.getItem(globalConfig.GROWER_ID));

  const nav = useNavigate();

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedParentIndex, setSelectedParentIndex] = useState(null);
  const [selectedProductIndex, setSelectedProductIndex] = useState(null);
  const [productDetail, setProductDetail] = useState(null);

  const queryClient = useQueryClient();
  const [openProduct, setOpenProduct] = useState({
    add: false,
    edit: false,
  });
  const [openCrop, setOpenCrop] = useState({
    add: false,
    edit: false,
  });
  const [cropDetail, setCropDetail] = useState(null);
  const [currentPage, setCurrentPage] = useState({
    cropPlanModelList: 1,
    cropPlanList: 1,
  });
  const [dataCount, setDataCount] = useState({
    cropPlanModelList: 10,
    cropPlanList: 10,
  });
  const [expandedFieldListRow, setExpandedFieldListRow] = useState(null);
  const [selectedField, setSelectedField] = useState([]);
  const [selectedFieldId, setSelectedFieldId] = useState([]);
  const [selectedSubfields, setSelectedSubfields] = useState([]);
  const [selectedCrop, setSelectedCrop] = useState("");
  const { data: cropListData, isLoading: isCropLoading } = useGet(
    ENDPOINTS.CROP_LIST,
    QUERY_KEYS.CROP_LIST_QUERY_KEY,
  );
  const {
    mutateAsync: editCropPlanMutateAsync,
    isLoading: isLoadingEditCropPlan,
  } = usePost(ENDPOINTS.EDIT_CROP_PLAN, QUERY_KEYS.EDIT_CROP_PLAN_QUERY_KEY);
  const { data: cropPlanDetail } = useGet(
    ENDPOINTS.CROP_PLAN_DETAIL,
    QUERY_KEYS.CROP_PLAN_DETAIL_QUERY_KEY,
    {
      seasonId: selectedSeasonId,
    },
  );
  const cropPlanDetailData = cropPlanDetail?.data;

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: cropPlanInitialValues,
    onSubmit: async (value) => {
      const data = {
        seasonId: selectedSeasonId,
        growerId: GrowerId,
        data: transformData(value.data).map((item) => ({
          ...item,
          cropName: getSelectedCrop(item.cropId)?.label,
        })),
      };

      try {
        const response = await editCropPlanMutateAsync(data);

        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.CROP_PLAN_DETAIL_QUERY_KEY],
        });

        AlertTost(response?.message, "success");
        resetForm();
        nav(WebRoutePath.GROWER_DETAIL.path);
      } catch (error) {
        toast.dismiss();
        AlertTost(error?.response?.data?.message, "error");
      }
    },
  });
  console.log(values.data, "ajayedit");

  const handelModalOpen = (parentIndex, index, key, data, productIndex) => {
    setOpenProduct({ ...openProduct, [key]: true });
    setSelectedIndex(index);
    setSelectedParentIndex(parentIndex);
    setSelectedProductIndex(productIndex);
    setProductDetail(data ?? null);
  };

  const handleAddCropProduct = (getValue, key, isEdit = false) => {
    setOpenProduct({ ...openProduct, [key]: true });

    if (
      typeof selectedParentIndex !== "undefined" &&
      typeof selectedIndex !== "undefined"
    ) {
      const updatedCropProtection = [
        ...values.data[selectedParentIndex].cropProtection,
      ];

      if (openProduct.edit && selectedProductIndex !== null) {
        // Edit existing product
        updatedCropProtection[selectedIndex].cropDetail[selectedProductIndex] =
          getValue;
      } else {
        // Add new product
        updatedCropProtection[selectedIndex].cropDetail.push(getValue);
      }

      setFieldValue(
        `data[${selectedParentIndex}].cropProtection`,
        updatedCropProtection,
      );
    } else {
      console.error(
        "Invalid indices: selectedParentIndex or selectedIndex is undefined",
      );
    }
  };

  // add placement
  const handleAddPlacement = async (parentIndex) => {
    const newPlacementIndex = values.data[parentIndex].fertility.length; // Get the current index

    const newPlacement = {
      products: [
        {
          soilTest: { N: "", P: "", K: "", S: "" },
          rate: "",
          actualValue: "0-0-0-0",
        },
      ],
      actualTotalValue: "0-0-0-0",
      placement: `Placement ${newPlacementIndex + 1}`,
    };
    await setFieldValue(`data[${parentIndex}].fertility`, [
      ...values.data[parentIndex].fertility,
      newPlacement,
    ]);
    const element = document.getElementById(
      `placement-${parentIndex}-${newPlacementIndex}`,
    );
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  // remove placement
  // const removePlacement = (parentIndex, placementIndex) => {
  //   // Clone the fertility array for the specific parentIndex
  //   const updatedFertility = [...values.data[parentIndex].fertility];

  //   // Remove the placement at the given index
  //   updatedFertility.splice(placementIndex, 1);

  //   // Update Formik state with the modified fertility array
  //   setFieldValue(`data[${parentIndex}].fertility`, updatedFertility);
  // };
  const removePlacement = (parentIndex, placementIndex) => {
    CustomAlert({
      title: "Are you sure you want to delete this placement?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: () => {
        // Safely clone the fertility array for the specific parentIndex
        const updatedFertility = values.data[parentIndex]?.fertility
          ? [...values.data[parentIndex].fertility]
          : [];

        if (placementIndex >= 0 && placementIndex < updatedFertility.length) {
          // Remove the placement at the given index
          updatedFertility.splice(placementIndex, 1);

          // Update Formik state with the modified fertility array
          setFieldValue(`data[${parentIndex}].fertility`, updatedFertility);
        } else {
          console.warn("Invalid placement index:", placementIndex);
        }
      },
    });
  };
  // Function to add a new product to a specific placement
  const handleAddProduct = (parentIndex, placementIndex) => {
    const fertilityPlacement =
      values.data[parentIndex].fertility[placementIndex];

    const lastProduct =
      fertilityPlacement.products[fertilityPlacement.products.length - 1];

    // Check if all soilTest values and rate are filled
    const isLastProductFilled =
      lastProduct &&
      lastProduct.rate !== "" &&
      lastProduct.soilTest.N !== "" &&
      lastProduct.soilTest.P !== "" &&
      lastProduct.soilTest.K !== "" &&
      lastProduct.soilTest.S !== "";

    if (!isLastProductFilled) {
      AlertTost(
        "Please fill all fields in the previous product before adding a new one.",
        "error",
      );

      return;
    }
    const newProduct = {
      soilTest: { N: "", P: "", K: "", S: "" },
      rate: "",
      actualValue: "0-0-0-0",
    };

    const updatedFertility = values.data[parentIndex].fertility.map(
      (placement, index) => {
        if (index === placementIndex) {
          return {
            ...placement,
            products: [...placement.products, newProduct],
          };
        }
        return placement;
      },
    );
    setFieldValue(`data[${parentIndex}].fertility`, updatedFertility);
  };
  // Function to remove product to a specific placement
  const removeProduct = (parentIndex, placementIndex, productIndex) => {
    CustomAlert({
      title: "Are you sure you want to delete this product?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: () => {
        const updatedFertility = values.data[parentIndex].fertility.map(
          (placement, pIndex) => {
            if (pIndex === placementIndex) {
              const updatedProducts = placement.products.filter(
                (_, index) => index !== productIndex,
              );
              return {
                ...placement,
                products: updatedProducts,
              };
            }
            return placement;
          },
        );
        setFieldValue(`data[${parentIndex}].fertility`, updatedFertility);
        // AlertTost("Product deleted successfully", "success");
      },
    });
  };

  const renderSoilTestInputs = (parentIndex, placementIndex, productIndex) => {
    return ["N", "P", "K", "S"].map((label) => (
      <input
        key={label}
        className="sol_input"
        placeholder={label}
        maxLength="2"
        name={`data[${parentIndex}].fertility[${placementIndex}].products[${productIndex}].soilTest.${label}`}
        value={
          values?.data?.[parentIndex]?.fertility?.[placementIndex]?.products?.[
            productIndex
          ]?.soilTest?.[label] || ""
        }
        onKeyPress={numberOnly}
        onChange={(e) => {
          handleChange(e);

          const newValue = e.target.value;
          const updatedSoilTest = {
            ...values?.data?.[parentIndex]?.fertility?.[placementIndex]
              ?.products?.[productIndex]?.soilTest,
            [label]: parseFloat(newValue) || 0,
          };

          CalculateActualValue(
            placementIndex,
            productIndex,
            updatedSoilTest,
            values,
            setFieldValue,
            parentIndex,
          );
        }}
        onBlur={handleBlur}
      />
    ));
  };
  const removeSelectedProduct = (
    parentIndex,
    cropProtectionIndex,
    productIndex,
  ) => {
    CustomAlert({
      title: "Are you sure you want to delete this product?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: () => {
        const updatedCropProtection = [
          ...values.data[parentIndex].cropProtection,
        ];
        updatedCropProtection[cropProtectionIndex].cropDetail =
          updatedCropProtection[cropProtectionIndex].cropDetail.filter(
            (_, index) => index !== productIndex,
          );

        // Update Formik state with the updated cropProtection
        setFieldValue(
          `data[${parentIndex}].cropProtection`,
          updatedCropProtection,
        );
        // AlertTost("Product deleted successfully", "success");
      },
    });
  };

  const onOpen = (key, data, parentIndex) => {
    setOpenCrop({ ...openCrop, [key]: true });
    setSelectedParentIndex(parentIndex);
    setCropDetail(data);
  };

  const onClose = (key) => {
    setOpenCrop({
      ...openCrop,
      [key]: false,
    });
    setCropDetail(null);
    setSelectedSubfields([]);
    setSelectedField([]);
    setSelectedFieldId([]);
  };

  useEffect(() => {
    if (!values?.data?.length) return;
    values.data.forEach((dataItem, parentIndex) => {
      dataItem?.fertility?.forEach((fertilityItem, placementIndex) => {
        fertilityItem?.products?.forEach((product, productIndex) => {
          const { rate, soilTest } = product;
          if (rate || soilTest) {
            CalculateActualValue(
              placementIndex,
              productIndex,
              soilTest,
              values,
              setFieldValue,
              parentIndex,
            );
          }
        });
      });
    });
  }, [values.data]);

  useEffect(() => {
    if (!values?.data?.length) return;
    values.data.forEach((dataItem, parentIndex) => {
      const newSum = CalculateSumOfActualValues(
        values,
        setFieldValue,
        parentIndex,
      );
      const currentTotalFertilizerNutrients =
        values?.data?.[parentIndex]?.totalFertilizerNutrients;

      if (currentTotalFertilizerNutrients !== newSum) {
        setFieldValue(`data[${parentIndex}].totalFertilizerNutrients`, newSum);
      }
    });
  }, [values.data]);

  const toggleFieldListRow = (index) => {
    setExpandedFieldListRow(expandedFieldListRow === index ? null : index);
  };
  const handlePagination = (type, action) => {
    setCurrentPage((prev) => ({
      ...prev,
      [type]: action === "next" ? prev[type] + 1 : prev[type] - 1,
    }));
  };

  const handleDataCountChange = (type, value) => {
    setDataCount((prev) => ({ ...prev, [type]: value }));
    setCurrentPage((prev) => ({ ...prev, [type]: 1 }));
  };
  const cropOptions = cropListData?.data?.map((item) => ({
    id: item?._id,
    value: item?._id,
    label: item?.name,
  }));

  const renderModalData = (cropId) => {
    return (
      <CropPlanModelFieldList
        setSelectedField={setSelectedField}
        currentPage={currentPage.cropPlanModelList}
        dataCount={dataCount.cropPlanModelList}
        expandedRow={expandedFieldListRow}
        handleNextPage={() => handlePagination("cropPlanModelList", "next")}
        handlePrevPage={() => handlePagination("cropPlanModelList", "prev")}
        onDataCountChange={(e) =>
          handleDataCountChange("cropPlanModelList", e.target.value)
        }
        toggleRow={toggleFieldListRow}
        selectedFieldId={selectedFieldId}
        selectedSubfields={selectedSubfields}
        setSelectedFieldId={setSelectedFieldId}
        setSelectedSubfields={setSelectedSubfields}
        selectedField={selectedField}
        cropId={cropId}
        cropYear={cropPlanDetailData?.cropPlanList[0]?.seasonId}
      />
    );
  };

  // get selected crop
  const getSelectedCrop = (cropId) => {
    return cropOptions?.find((crop) => crop.value === cropId) || null;
  };

  const handleDeleteItem = (parentIndex) => {
    CustomAlert({
      title: "Are you sure you want to delete this?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: () => {
        const updatedData = values.data.filter(
          (_, index) => index !== parentIndex,
        );
        setFieldValue("data", updatedData);
        // AlertTost("Item deleted successfully", "success");
      },
    });
  };

  useEffect(() => {
    if (cropPlanDetailData) {
      const transformedData = transformCropPlanData(cropPlanDetailData);
      const selectedField =
        transformedData.data?.find((field) =>
          field.fieldId?.includes(selectedFieldId),
        ) || [];
      const selectedSubfields = selectedField?.subFieldIds || [];
      setSelectedField(selectedField || []);
      setSelectedSubfields(selectedSubfields);
      setValues(transformedData);
    }
  }, [cropPlanDetailData]);

  return (
    <WebLayout>
      <section className="main-section spacer">
        <div className="container">
          <div className="row gy-4">
            <div className="col-12">
              <div className="d-flex justify-content-end">
                <button className="primary-btn" onClick={() => onOpen("add")}>
                  Add crop
                </button>
              </div>
            </div>
            <div className="flex_wrap_container">
              {values?.data?.map((parentItem, parentIndex) => {
                const totalAcres = parentItem?.fieldData?.reduce(
                  (sum, data) => sum + (Number(data?.area) || 0),
                  0,
                );
                // const isLastIndex = parentIndex === values?.data?.length - 1;
                const isEvenIndex = parentIndex % 2 === 0;

                return (
                  <div
                    className="row flex_inner_box border_primary d-flex flex-column gap-3 pb-3 position-relative"
                    style={{
                      background: isEvenIndex
                        ? "rgba(218, 242, 186, 1)"
                        : "rgba(224, 224, 224, 1)",
                    }}
                  >
                    <div className="new_file_preview_item2">
                      {values?.data?.length > 1 && (
                        <button
                          className="remove_file"
                          onClick={() => handleDeleteItem(parentIndex)}
                        >
                          <i className="fa fa-solid fa-xmark"></i>
                        </button>
                      )}
                    </div>

                    <div className="col-12">
                      <div className="d-flex justify-content-between align-items-center gap-3 mb-4">
                        <div className="add_crop_wrapper_card mb-0">
                          <form>
                            <div className="row justify-content-between gy-3 gx-5">
                              <div className="col-xl-12">
                                <div className="top-detail d-flex justify-content-between align-items-center gap-3 mb-2">
                                  <h2 className="h4 text-black mb-0">
                                    {getSelectedCrop(parentItem?.cropId)?.label}
                                  </h2>
                                  <button
                                    className="edit_underline_btn"
                                    type="button"
                                    onClick={() =>
                                      onOpen("edit", parentItem, parentIndex)
                                    }
                                  >
                                    <svg
                                      width="23"
                                      height="23"
                                      viewBox="0 0 23 23"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12.3125 3.34264L4.68897 11.4119C4.40112 11.7184 4.12254 12.3219 4.06683 12.7398L3.72326 15.7484C3.60254 16.8348 4.38254 17.5776 5.45969 17.3919L8.44969 16.8812C8.86755 16.8069 9.45254 16.5005 9.7404 16.1848L17.364 8.1155C18.6825 6.72264 19.2768 5.13478 17.2247 3.19407C15.1818 1.27193 13.6311 1.94978 12.3125 3.34264Z"
                                        stroke="#292D32"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M11.041 4.68945C11.4403 7.25231 13.5203 9.2116 16.1017 9.4716"
                                        stroke="#292D32"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M2.78516 20.4287H19.4994"
                                        stroke="#292D32"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </button>
                                </div>
                                <div className="common-statistics">
                                  <div className="common-info-detail">
                                    <h2 className="h4 text-black text-wrap">
                                      {parentItem?.description}
                                    </h2>
                                  </div>
                                  {parentItem?.fieldData.length === 0 ? (
                                    <div className="common-info-detail mb-2">
                                      <h2 className="h4 text-black fw-bold">
                                        Acres
                                      </h2>
                                      <p className="mb-0 fw-bold">
                                        {parentItem?.acresValue}
                                      </p>
                                    </div>
                                  ) : (
                                    <>
                                      <div className="border-bottom pb-2 d-flex justify-content-between align-items-center gap-3 mb-2">
                                        <h2 className="h4 text-black mb-0">
                                          Field Name
                                        </h2>
                                        <h2 className="h4 text-black mb-0">
                                          Acres
                                        </h2>
                                      </div>
                                      {parentItem?.fieldData?.map((data, i) => (
                                        <div className="" key={i}>
                                          <div className="common-info-detail">
                                            <p>{data?.name}</p>
                                            <p className="mb-0">{data?.area}</p>
                                          </div>
                                        </div>
                                      ))}
                                    </>

                                    // parentItem?.fieldData?.map((data, i) => {
                                    //   return (
                                    //     <div className="field_detail_container">
                                    //       <div
                                    //         className="common-info-detail gap-0"
                                    //         key={i}
                                    //       >
                                    //         <h2 className="h4 text-black">
                                    //           Field
                                    //         </h2>
                                    //         <p className="mb-0">{data?.name}</p>
                                    //       </div>
                                    //       <div
                                    //         className="common-info-detail"
                                    //         key={i}
                                    //       >
                                    //         <h2 className="h4 text-black">
                                    //           Acres
                                    //         </h2>
                                    //         <p className="mb-0">{data?.area}</p>
                                    //       </div>
                                    //     </div>
                                    //   );
                                    // })
                                  )}
                                  {parentItem?.fieldData.length === 0 ? null : (
                                    <div className="mt-1">
                                      <div className="common-info-detail">
                                        <p className="fw-bold m-0 text-black">
                                          Total Acres
                                        </p>
                                        <p className="mb-0 fw-bold ">
                                          {totalAcres}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <FertilityComponent
                        renderSoilTestInputs={renderSoilTestInputs}
                        values={values}
                        handleAddPlacement={handleAddPlacement}
                        handleAddProduct={handleAddProduct}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        parentIndex={parentIndex}
                        handelRemoveProduct={removeProduct}
                        handelRemovePlacement={removePlacement}
                      />
                    </div>
                    <div className="col-lg-12">
                      <SeedComponent
                        values={values}
                        errors={errors}
                        touched={touched}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        parentIndex={parentIndex}
                      />
                    </div>
                    <div className="col-lg-12">
                      <CropProtectionComponent
                        values={values}
                        handelModalOpen={handelModalOpen}
                        removeSelectedProduct={removeSelectedProduct}
                        parentIndex={parentIndex}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {values?.data?.length === 0 ? null : (
          <button
            className="primary-btn mt-5"
            type="button"
            onClick={handleSubmit}
            disabled={isLoadingEditCropPlan}
          >
            {isLoadingEditCropPlan ? (
              <ClipLoader size={17} color="#fff" />
            ) : (
              "Save"
            )}
          </button>
        )}

        <CropAddProductModel
          open={openProduct}
          setOpen={setOpenProduct}
          handleAddCropProduct={handleAddCropProduct}
          productDetail={productDetail}
          setProductDetail={setProductDetail}
        />
      </section>
      <AddCropModel
        cropDetail={cropDetail}
        cropOptions={cropOptions}
        getSelectedCrop={getSelectedCrop}
        isCropLoading={isCropLoading}
        onClose={onClose}
        openCrop={openCrop}
        renderModalData={renderModalData}
        selectedCrop={selectedCrop}
        selectedField={selectedField}
        selectedFieldId={selectedFieldId}
        selectedSubfields={selectedSubfields}
        setSelectedCrop={setSelectedCrop}
        setSelectedField={setSelectedField}
        setSelectedFieldId={setSelectedFieldId}
        setSelectedSubfields={setSelectedSubfields}
        setFieldValue={setFieldValue}
        values={values}
        parentIndex={selectedParentIndex}
        setValues={setValues}
      />
    </WebLayout>
  );
};

export default CropPlaneEdit;
